import { active } from "@api/stores/suppliers/active/path";
import { deactive } from "@api/stores/suppliers/deactive/path";
import { stats } from "@api/stores/suppliers/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/suppliers/`;
const pathById = `${pathBase}:supplierId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const suppliers = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  active,
  deactive,
  stats,
};
